export enum PaymentProvider {
  NA = 'NA',
  FakePaymentMethod = 'fakePaymentMethod',
  Stripe = 'com.stripe',
  Square = 'com.square',
  PayPal = 'payPal',
  MercadoPago = 'mercadoPago',
  PagSeguro = 'pagSeguro',
  Worldpay = 'com.worldpay.smb',
  Fatzebra = 'au.com.fatzebra',
  Yandex = 'yandex',
  Eway = 'com.eway',
  Braintreegateway = 'com.braintreegateway',
  TwoCheckout = 'com.2checkout',
  Wirecard = 'com.wirecard',
  LeumiCard = 'il.co.shva.zooz',
  CitrusPay = 'com.citruspay',
  PayUTurkey = 'tr.payu',
  AuthorizeNET = 'net.authorize',
  Dlocal = 'com.dlocal',
  WixPayBR = 'com.wix.wixpay',
  WixPayUS = 'com.wix.wixpay.us',
  CreditGuard = 'il.co.creditguard',
  DengiOnline = 'com.dengionline',
  PaymentExpress = 'com.paymentexpress',
  PagueloFacil = 'com.paguelofacil',
  SumUp = 'sumUp',
  Isracard = 'il.co.isracard',
  Epsilon = 'jp.epsilon',
  Interkassa = '569a9662-9bf9-49b5-a5dd-5f1528c6100d',
  UniPay = 'c7ed6c23-dad5-47a2-be03-b7808f6817d7',
  BitPay = '594e74f7-5543-42f4-bd30-efbee3ea51b1',
  Afterpay = '385bfbe3-01cb-4544-86aa-41f3828b50ad',
  Lyra = 'c9a1097e-ae74-4752-af9c-1d742cca6589',
  Laybuy = '70153d33-fdf7-425d-8eb3-bdb18475cd12',
  Pinwheel = '239e7846-6f6c-4801-86bc-d14b9151c534',
  Iyzico = 'f748e7fb-1694-42b9-afec-19e27c62f32b',
  OceanPayment = '7282b19d-356a-47b7-b278-f8001e52f777',
  DPO = '78c74b98-9016-4b27-a0fb-a0a9d47d9a5d',
  Portmone = 'fe79bb94-a8fc-49e0-8085-f17bb77f1b12',
  Fondy = 'd023ca2e-48ae-4e53-b6e4-86169e4fa478',
  PayUPoland = 'c3eb915c-04c5-4c0e-963d-35a77f83567c',
  PayUColombia = '527b0adc-6789-4fd0-8755-f236bb9a40aa',
  Komoju = '061f7698-7f09-4a7c-9092-91b1e598163d',
}
